import axios from 'axios';
import filter from 'lodash/fp/filter';
import find from 'lodash/fp/find';
import fetchSelfData from './lib/fetchSelfFavorites';
import fetchSelf from './lib/fetchSelf';
import updateSelf from './lib/updateSelf';

axios.defaults.withCredentials = true;

/* global document, window, jQuery */
(() => {
  const updateButtons = async () => {
    const buttons = document.querySelectorAll('.scholarship-favorite');
    const { uuid: userId } = await fetchSelf();
    if (userId) {
      let { fieldFavorites: data } = await fetchSelfData();
      buttons.forEach((button) => {
        button.addEventListener('click', async (evt) => {
          evt.preventDefault();
          const id = button.getAttribute('data-entity-id');
          if (find({ id }, data)) {
            data = filter((item) => item.id !== id, data);
            button.classList.remove('is-favorited');
            button.classList.add('is-not-favorited');
          } else {
            data = [...data, { id, type: 'node--scholarship' }];
            button.classList.add('is-favorited');
            button.classList.remove('is-not-favorited');
          }
          const relationships = {
            field_favorites: {
              data,
            },
          };
          await updateSelf({ relationships });
        });
        button.classList.add('is-loaded');
      });
    } else {
      buttons.forEach((button) => {
        button.addEventListener('click', async (evt) => {
          evt.preventDefault();
          const id = button.getAttribute('data-entity-id');
          if (button.classList.contains('is-favorited')) {
            button.classList.remove('is-favorited');
            button.classList.add('is-not-favorited');
          } else {
            button.classList.add('is-favorited');
            button.classList.remove('is-not-favorited');
          }
          await axios.get(`/anon/favorite/${id}`);
        });
        button.classList.add('is-loaded');
      });
    }
  };
  updateButtons();
  jQuery(window).ajaxComplete(updateButtons);
})();
